export async function getApps() {
  return [
    {
      // 1. /activa/plist origin mfe: micro-vue3-plist-memoria
      id: '',
      name: `${process.env.VUE_APP_MICRO_VUE3_NAME_PLIST}`,
      entry: `${process.env.VUE_APP_GLOBAL_BASE_URL}/child/${process.env.VUE_APP_MICRO_VUE3_NAME_PLIST}/`,
      container: `#${process.env.VUE_APP_MICRO_VUE3_CONTAINER_PLIST}`,
      activeRule: `${process.env.VUE_APP_GLOBAL_BASE_URL}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_PLIST}`,
      icon: ''
    },
    {
      // 3. /activa/projecte/memoria origin mfe: micro-vue3-plist-memoria
      id: '',
      name: `${process.env.VUE_APP_MICRO_VUE3_NAME_MEMORIA}`,
      entry: `${process.env.VUE_APP_GLOBAL_BASE_URL}/child/${process.env.VUE_APP_MICRO_VUE3_NAME_MEMORIA}/`,
      container: `#${process.env.VUE_APP_MICRO_VUE3_CONTAINER_MEMORIA}`,
      activeRule: `${process.env.VUE_APP_GLOBAL_BASE_URL}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_PLIST}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_VISTA_PROJECTE}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_MEMORIA}`,
      icon: ''
    },
    {
      // 4. /activa/projecte/execucio
      id: '',
      name: `${process.env.VUE_APP_MICRO_VUE3_NAME_EXECUCIO}`,
      entry: `${process.env.VUE_APP_GLOBAL_BASE_URL}/child/${process.env.VUE_APP_MICRO_VUE3_NAME_EXECUCIO}/`,
      container: `#${process.env.VUE_APP_MICRO_VUE3_CONTAINER_EXECUCIO}`,
      activeRule: `${process.env.VUE_APP_GLOBAL_BASE_URL}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_PLIST}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_VISTA_PROJECTE}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_EXECUCIO}`,
      icon: ''
    },
    {
      // 5. /activa/plist/projecte/justificacio-tecnica
      id: '',
      name: `${process.env.VUE_APP_MICRO_VUE3_NAME_JUSTIFICACIO_TECNICA}`,
      entry: `${process.env.VUE_APP_GLOBAL_BASE_URL}/child/${process.env.VUE_APP_MICRO_VUE3_NAME_JUSTIFICACIO_TECNICA}/`,
      container: `#${process.env.VUE_APP_MICRO_VUE3_CONTAINER_JUSTIFICACIO_TECNICA}`,
      activeRule: `${process.env.VUE_APP_GLOBAL_BASE_URL}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_PLIST}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_VISTA_PROJECTE}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_JUSTIFICACIO_TECNICA}`,
      icon: ''
    },
    {
      // 6. /activa/plist/projecte/justificacio-economica
      id: '',
      name: `${process.env.VUE_APP_MICRO_VUE3_NAME_JUSTIFICACIO_ECONOMICA}`,
      entry: `${process.env.VUE_APP_GLOBAL_BASE_URL}/child/${process.env.VUE_APP_MICRO_VUE3_NAME_JUSTIFICACIO_ECONOMICA}/`,
      container: `#${process.env.VUE_APP_MICRO_VUE3_CONTAINER_JUSTIFICACIO_ECONOMICA}`,
      activeRule: `${process.env.VUE_APP_GLOBAL_BASE_URL}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_PLIST}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_VISTA_PROJECTE}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_JUSTIFICACIO_ECONOMICA}`,
      icon: ''
    },
    {
      // 7. /activa/plist/projecte/finalitzar
      id: '',
      name: `${process.env.VUE_APP_MICRO_VUE3_NAME_FINALITZAR}`,
      entry: `${process.env.VUE_APP_GLOBAL_BASE_URL}/child/${process.env.VUE_APP_MICRO_VUE3_NAME_FINALITZAR}/`,
      container: `#${process.env.VUE_APP_MICRO_VUE3_CONTAINER_FINALITZAR}`,
      activeRule: `${process.env.VUE_APP_GLOBAL_BASE_URL}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_PLIST}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_VISTA_PROJECTE}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_FINALITZAR}`,
      icon: ''
    },
    {
      // 8. /activa/plist/projecte/impacte
      id: '',
      name: `${process.env.VUE_APP_MICRO_VUE3_NAME_IMPACTE}`,
      entry: `${process.env.VUE_APP_GLOBAL_BASE_URL}/child/${process.env.VUE_APP_MICRO_VUE3_NAME_IMPACTE}/`,
      container: `#${process.env.VUE_APP_MICRO_VUE3_CONTAINER_IMPACTE}`,
      activeRule: `${process.env.VUE_APP_GLOBAL_BASE_URL}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_PLIST}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_VISTA_PROJECTE}${process.env.VUE_APP_MICRO_VUE3_ACTIVERULE_IMPACTE}`,
      icon: ''
    }
  ]
}